<template>
  <view-loader :loading="!!loading">
    <div class="portlet-body form">
      <form action="#" class="form-horizontal">
        <div class="form-body">
          <h3 class="form-section" style="margin-top: 0px">{{ trans('importPpk.import.form.header') }}</h3>
          <div class="row">
            <div class="col-md-6">
              <upload-file
                  name="file"
                  v-model="file"
                  accept=".xlsx"
                  :errors="errors"
                  :title="trans('importPpk.messages.acceptable_import_file_extensions')"
              >
              </upload-file>
            </div>
          </div>
          <hr style="margin: 0 "/>
          <div class="form-actions top">
            <div class="btn-set pull-right">
              <button
                  type="button"
                  class="btn green-jungle button-save"
                  id="button-save-and-back"
                  @click="importAddress"
                  data-loading-text="<i class='fa fa-spinner fa-spin '></i>">
                {{ trans('offer.import.import') }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <modal
        :show="showModal"
        @close="showModal = false"
        :modalBodyText="modalBodyText">
      <template #header>
        <h3>{{ trans('importPpk.modal.header') }}</h3>
      </template>
    </modal>
  </view-loader>
</template>

<script>
import UploadFile from '@component/dccore-form/uploadFile.vue'
import ViewLoader from '@component/ViewLoader.vue'
import axios from 'axios'
import Modal from '@component/modal.vue'

export default {
  name: 'ImportPpk',
  components: {
    UploadFile,
    ViewLoader,
    Modal
  },
  data() {
    return {
      file: null,
      errors: {},
      loading: false,
      showModal: false,
      modalBodyText: ''
    }
  },
  methods: {
    importAddress() {
      this.loading = true

      const url = Routing.generate('api_import_ppk_for_bags')
      const data = {
        file : this.file
      }

      axios.post(url, data).then(response => {
        this.modalBodyText = response.data.message
      }, response => {
        this.modalBodyText = response.response.data.message
      }).finally(() => {
        this.showModal = true
        this.loading = false
      })
    }
  }
}
</script>
